// extracted by mini-css-extract-plugin
export default {"productCarousel":"W3-z"};